import _ from "lodash";
import { BILLING_CYCLE, PlanModelInfo, planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';
import { flowTypes, pageConfig } from '@/common/service/page-config';

const masterClassKey = 'masterclass';

export default (planMapJSON = {}) => {
  const masterClass = planMapJSON[masterClassKey];

  if (!masterClass) return [];

  // new subscription have license limit with zoom one plan
  const isNeedDependBasePlan = [flowTypes.buyNow, flowTypes.basic2pro, flowTypes.add2cart, flowTypes.mixBuy].includes(pageConfig.type);
  const licenseDependBasePlanTypeList = isNeedDependBasePlan ? [planTypes.ZOOM_MEETING] : [];

  return _.map(defaultMapper(masterClass, planTypes.MASTER_CLASS), (item) => {
    return {
      ...item,
      billing_cycle: BILLING_CYCLE.ONE_TIME,
      typeNameKey: 'billing.partner.masterclass.title',
      min: 1,
      max: 99,
      parent_category: planTypes.MASTER_CLASS,
      licenseDependBasePlanTypeList,
      supportCoupon: true,
      externalProduct: true,
      planPeriod: masterClass?.planPeriod ?? 12,
      considerLicenseLimit: true,
      planModel: PlanModelInfo.license
    };
  });
}
